import { useState, useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import ModalWaiting from "../Components/ModalWaiting";

function AdminDashboard() {
  const [uuid, setUuid] = useState("");
  const [userData, setUserData] = useState(null);
  const [paypayLink, setPaypayLink] = useState("");
  
  const [modalshow, setModalshow] = useState(true);
  const [waitingShow, setWaitingShow] = useState(false);
  
  const [message, setMessage] = useState({ type: "", text: "" });

  const gasBaseUrl = "https://script.google.com/macros/s/AKfycbxV78M9f2XuypgAEfJ3An-chZD1b_FmDONcUuuP9gCCMdY8hwCrGBatowwBVEXxIevS6A/exec";

  useEffect(() => {
    document.title = "管理ダッシュボード";
    const queries = new URLSearchParams(window.location.search);
    const targetUuid = queries.get('uuid');

    if (targetUuid) {
      setUuid(targetUuid);
      fetchUserData(targetUuid);
    } else {
      setMessage({ type: "danger", text: "エラー: UUIDが指定されていません。" });
      setModalshow(false);
    }
  }, []);

  const fetchUserData = async (targetUuid) => {
    try {
      const response = await fetch(gasBaseUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify({
          action: "getAdminUserData",
          uuid: targetUuid
        })
      });
      
      const result = await response.json();
      
      if (result.error) {
        setMessage({ type: "danger", text: result.error });
      } else {
        setUserData(result.data);
      }
    } catch (err) {
      setMessage({ type: "danger", text: "データの取得に失敗しました。" });
    } finally {
      setModalshow(false);
    }
  };

  const handlePasteFromClipboard = async () => {
    try {
      const text = await navigator.clipboard.readText();
      setPaypayLink(text);
      setMessage({ type: "success", text: "リンクを貼り付けました！送信ボタンを押してください。" });
    } catch (err) {
      console.error('Failed to read clipboard contents: ', err);
      setMessage({ type: "warning", text: "貼り付けに失敗しました。ブラウザの権限が許可されていないか、対応していない環境です。手動で長押しして貼り付けてください。" });
    }
  };

  const handleSendLink = async () => {
    if (!paypayLink.trim()) {
      setMessage({ type: "warning", text: "PayPayの請求リンクを入力してください。" });
      return;
    }

    setWaitingShow(true);
    setMessage({ type: "", text: "" });

    // ★ 修正：現在のステータスが残金請求フェーズかどうかを判定
    const isBalancePhase = userData.status.includes("07_") || userData.status.includes("08_") || userData.status.includes("09_");

    try {
      const response = await fetch(gasBaseUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify({
          action: "sendPayPayLink",
          uuid: uuid,
          paypayLink: paypayLink.trim(),
          userID: userData.userID,
          userName: userData.userName,
          isBalance: isBalancePhase // ★ 修正：GAS側でどちらのリンクとして記録するか判別させる
        })
      });

      const result = await response.json();

      if (result.success) {
        setMessage({ type: "success", text: "LINEへの送信と記録が完了しました！" });
        // ★ 修正：フェーズに合わせてローカルのステートも個別に更新する
        if (isBalancePhase) {
           setUserData({ ...userData, isBalancePayPaySent: true });
        } else {
           setUserData({ ...userData, isPayPaySent: true });
        }
      } else {
        setMessage({ type: "danger", text: "送信エラー: " + (result.error || "不明なエラー") });
      }
    } catch (err) {
      setMessage({ type: "danger", text: "通信エラーが発生しました。" });
    } finally {
      setWaitingShow(false);
    }
  };

  const isValidLink = paypayLink.trim().startsWith("https://");

  // ★ 修正：ステータスを見て、現在「着手金」と「残金」どちらのフェーズかを判定
  const isBalancePhase = userData?.status && (userData.status.includes("07_") || userData.status.includes("08_") || userData.status.includes("09_"));
  // フェーズに応じて、どちらの「送信済みフラグ」を見るか切り替える
  const isCurrentlySent = isBalancePhase ? userData?.isBalancePayPaySent : userData?.isPayPaySent;

  return (
    <>
      <div className="p-3 bg-light min-vh-100 d-flex justify-content-center align-items-start pt-5">
        <Card className="w-100 shadow-sm border-0" style={{ maxWidth: '600px' }}>
          <Card.Header className="bg-primary text-white fw-bold text-center py-3">
            顧客対応ダッシュボード
          </Card.Header>
          <Card.Body className="p-4">
            
            {message.text && <Alert variant={message.type}>{message.text}</Alert>}

            {userData ? (
              <>
                <div className="mb-4 p-3 bg-white border rounded shadow-sm">
                  <div className="mb-2"><small className="text-muted">お名前:</small> <span className="fw-bold fs-5">{userData.userName} 様</span></div>
                  <div className="mb-2"><small className="text-muted">管理ID:</small> <span className="fw-bold">{uuid}</span></div>
                  <div className="mb-2"><small className="text-muted">支払方法:</small> <span className="fw-bold text-danger">{userData.payMethod}</span></div>
                  <div><small className="text-muted">ステータス:</small> <span className="fw-bold">{userData.status}</span></div>
                </div>

                {userData.payMethod === "PayPay" ? (
                  <div className="bg-light p-3 border rounded">
                    <h6 className="fw-bold mb-3 text-primary">
                       PayPay請求リンクの送信 {isBalancePhase ? "(残金用)" : "(着手金用)"}
                    </h6>
                    
                    {/* ★ 修正：フェーズに合わせた送信済みフラグ (isCurrentlySent) で判定 */}
                    {isCurrentlySent ? (
                      <Alert variant="success" className="text-center fw-bold">
                        請求リンクは送信済みです。
                      </Alert>
                    ) : (
                      <>
                        <Form.Group className="mb-3">
                          <Form.Label className="small fw-bold">アプリで作成した請求リンクURL</Form.Label>
                          <InputGroup>
                            <Form.Control 
                              type="url" 
                              placeholder="https://paypay.ne.jp/..." 
                              value={paypayLink}
                              onChange={(e) => setPaypayLink(e.target.value)}
                              disabled={waitingShow}
                              isInvalid={paypayLink.length > 0 && !isValidLink}
                            />
                            <Button 
                              variant="outline-secondary" 
                              onClick={handlePasteFromClipboard}
                              disabled={waitingShow}
                              className="fw-bold bg-white"
                            >
                              貼り付け
                            </Button>
                            <Form.Control.Feedback type="invalid">
                              正しいURL（https://〜）を入力してください
                            </Form.Control.Feedback>
                          </InputGroup>
                        </Form.Group>
                        
                        <Button 
                          variant="primary" 
                          className="w-100 fw-bold py-2 mt-2" 
                          onClick={handleSendLink}
                          disabled={waitingShow || !isValidLink}
                        >
                          LINEへ請求リンクを送信する
                        </Button>
                      </>
                    )}
                  </div>
                ) : (
                  <Alert variant="info" className="text-center">
                    このお客様は銀行振込（または別手段）です。<br/>PayPayリンクの送信は不要です。
                  </Alert>
                )}
              </>
            ) : (
              !modalshow && !message.text && <Alert variant="warning">データが見つかりませんでした。</Alert>
            )}

          </Card.Body>
        </Card>
      </div>

      <ModalWaiting show={modalshow || waitingShow} />
    </>
  );
}

export default AdminDashboard;
